import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { Buffer } from "buffer";
import { SYS_ENCRYPT } from "../../config/invariant.config";
declare var JSEncrypt;

/*
  Generated class for the JmSerProvider provider.
*/
@Injectable()
export class EncryptionSerProvider {
  constructor() {}

  public encryptions = () => {
    /*
     * Configurable variables. You may need to tweak these to be compatible with
     * the server-side, but the defaults work in most cases.
     */
    var hexcase = 0; /* hex output format. 0 - lowercase; 1 - uppercase        */
    var b64pad =
      ""; /* base-64 pad character. "=" for strict RFC compliance   */
    var chrsz = 8; /* bits per input character. 8 - ASCII; 16 - Unicode      */

    /*
     * Calculate the MD5 of an array of little-endian words, and a bit length
     */
    function core_md5(x, len) {
      /* append padding */
      x[len >> 5] |= 0x80 << len % 32;
      x[(((len + 64) >>> 9) << 4) + 14] = len;

      var a = 1732584193;
      var b = -271733879;
      var c = -1732584194;
      var d = 271733878;

      for (var i = 0; i < x.length; i += 16) {
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;

        a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
        d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

        a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
        a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

        a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
        c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

        a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
        d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

        a = safe_add(a, olda);
        b = safe_add(b, oldb);
        c = safe_add(c, oldc);
        d = safe_add(d, oldd);
      }
      return Array(a, b, c, d);
    }

    /*
     * These functions implement the four basic operations the algorithm uses.
     */
    function md5_cmn(q, a, b, x, s, t) {
      return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
    }
    function md5_ff(a, b, c, d, x, s, t) {
      return md5_cmn((b & c) | (~b & d), a, b, x, s, t);
    }
    function md5_gg(a, b, c, d, x, s, t) {
      return md5_cmn((b & d) | (c & ~d), a, b, x, s, t);
    }
    function md5_hh(a, b, c, d, x, s, t) {
      return md5_cmn(b ^ c ^ d, a, b, x, s, t);
    }
    function md5_ii(a, b, c, d, x, s, t) {
      return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
    }

    /*
     * Calculate the HMAC-MD5, of a key and some data
     */
    function core_hmac_md5(key, data) {
      var bkey = str2binl(key);
      if (bkey.length > 16) bkey = core_md5(bkey, key.length * chrsz);

      var ipad = Array(16),
        opad = Array(16);
      for (var i = 0; i < 16; i++) {
        ipad[i] = bkey[i] ^ 0x36363636;
        opad[i] = bkey[i] ^ 0x5c5c5c5c;
      }

      var hash = core_md5(
        ipad.concat(str2binl(data)),
        512 + data.length * chrsz,
      );
      return core_md5(opad.concat(hash), 512 + 128);
    }

    /*
     * Bitwise rotate a 32-bit number to the left.
     */
    function bit_rol(num, cnt) {
      return (num << cnt) | (num >>> (32 - cnt));
    }

    /*
     * Convert a string to an array of little-endian words
     * If chrsz is ASCII, characters >255 have their hi-byte silently ignored.
     */
    function str2binl(str) {
      var bin = Array();
      var mask = (1 << chrsz) - 1;
      for (var i = 0; i < str.length * chrsz; i += chrsz)
        bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << i % 32;
      return bin;
    }

    /*
     * Convert an array of little-endian words to a string
     */
    function binl2str(bin) {
      var str = "";
      var mask = (1 << chrsz) - 1;
      for (var i = 0; i < bin.length * 32; i += chrsz)
        str += String.fromCharCode((bin[i >> 5] >>> i % 32) & mask);
      return str;
    }

    /*
     * Convert an array of little-endian words to a hex string.
     */
    function binl2hex(binarray) {
      var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
      var str = "";
      for (var i = 0; i < binarray.length * 4; i++) {
        str +=
          hex_tab.charAt((binarray[i >> 2] >> ((i % 4) * 8 + 4)) & 0xf) +
          hex_tab.charAt((binarray[i >> 2] >> ((i % 4) * 8)) & 0xf);
      }
      return str;
    }

    /*
     * Convert an array of little-endian words to a base-64 string
     */
    function binl2b64(binarray) {
      var tab =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      var str = "";
      for (var i = 0; i < binarray.length * 4; i += 3) {
        var triplet =
          (((binarray[i >> 2] >> (8 * (i % 4))) & 0xff) << 16) |
          (((binarray[(i + 1) >> 2] >> (8 * ((i + 1) % 4))) & 0xff) << 8) |
          ((binarray[(i + 2) >> 2] >> (8 * ((i + 2) % 4))) & 0xff);
        for (var j = 0; j < 4; j++) {
          if (i * 8 + j * 6 > binarray.length * 32) str += b64pad;
          else str += tab.charAt((triplet >> (6 * (3 - j))) & 0x3f);
        }
      }
      return str;
    }

    /*
     * Calculate the sha256 of a raw string
     */
    function rstr_sha256(s) {
      return binb2rstr(binb_sha256(rstr2binb(s), s.length * 8));
    }

    /*
     * Calculate the HMAC-sha256 of a key and some data (raw strings)
     */
    function rstr_hmac_sha256(key, data) {
      var bkey = rstr2binb(key);
      if (bkey.length > 16) bkey = binb_sha256(bkey, key.length * 8);

      var ipad = Array(16),
        opad = Array(16);
      for (var i = 0; i < 16; i++) {
        ipad[i] = bkey[i] ^ 0x36363636;
        opad[i] = bkey[i] ^ 0x5c5c5c5c;
      }

      var hash = binb_sha256(
        ipad.concat(rstr2binb(data)),
        512 + data.length * 8,
      );
      return binb2rstr(binb_sha256(opad.concat(hash), 512 + 256));
    }

    /*
     * Convert a raw string to a hex string
     */
    function rstr2hex(input) {
      try {
        hexcase;
      } catch (e) {
        hexcase = 0;
      }
      var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
      var output = "";
      var x;
      for (var i = 0; i < input.length; i++) {
        x = input.charCodeAt(i);
        output += hex_tab.charAt((x >>> 4) & 0x0f) + hex_tab.charAt(x & 0x0f);
      }
      return output;
    }

    /*
     * Convert a raw string to a base-64 string
     */
    function rstr2b64(input) {
      try {
        b64pad;
      } catch (e) {
        b64pad = "";
      }
      var tab =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      var output = "";
      var len = input.length;
      for (var i = 0; i < len; i += 3) {
        var triplet =
          (input.charCodeAt(i) << 16) |
          (i + 1 < len ? input.charCodeAt(i + 1) << 8 : 0) |
          (i + 2 < len ? input.charCodeAt(i + 2) : 0);
        for (var j = 0; j < 4; j++) {
          if (i * 8 + j * 6 > input.length * 8) output += b64pad;
          else output += tab.charAt((triplet >>> (6 * (3 - j))) & 0x3f);
        }
      }
      return output;
    }

    /*
     * Convert a raw string to an arbitrary string encoding
     */
    function rstr2any(input, encoding) {
      var divisor = encoding.length;
      var remainders = Array();
      var i, q, x, quotient;

      /* Convert to an array of 16-bit big-endian values, forming the dividend */
      var dividend = Array(Math.ceil(input.length / 2));
      for (i = 0; i < dividend.length; i++) {
        dividend[i] =
          (input.charCodeAt(i * 2) << 8) | input.charCodeAt(i * 2 + 1);
      }

      /*
       * Repeatedly perform a long division. The binary array forms the dividend,
       * the length of the encoding is the divisor. Once computed, the quotient
       * forms the dividend for the next step. We stop when the dividend is zero.
       * All remainders are stored for later use.
       */
      while (dividend.length > 0) {
        quotient = Array();
        x = 0;
        for (i = 0; i < dividend.length; i++) {
          x = (x << 16) + dividend[i];
          q = Math.floor(x / divisor);
          x -= q * divisor;
          if (quotient.length > 0 || q > 0) quotient[quotient.length] = q;
        }
        remainders[remainders.length] = x;
        dividend = quotient;
      }

      /* Convert the remainders to the output string */
      var output = "";
      for (i = remainders.length - 1; i >= 0; i--)
        output += encoding.charAt(remainders[i]);

      /* Append leading zero equivalents */
      var full_length = Math.ceil(
        (input.length * 8) / (Math.log(encoding.length) / Math.log(2)),
      );
      for (i = output.length; i < full_length; i++)
        output = encoding[0] + output;

      return output;
    }

    /*
     * Encode a string as utf-8.
     * For efficiency, this assumes the input is valid utf-16.
     */
    function str2rstr_utf8(input) {
      var output = "";
      var i = -1;
      var x, y;

      while (++i < input.length) {
        /* Decode utf-16 surrogate pairs */
        x = input.charCodeAt(i);
        y = i + 1 < input.length ? input.charCodeAt(i + 1) : 0;
        if (0xd800 <= x && x <= 0xdbff && 0xdc00 <= y && y <= 0xdfff) {
          x = 0x10000 + ((x & 0x03ff) << 10) + (y & 0x03ff);
          i++;
        }

        /* Encode output as utf-8 */
        if (x <= 0x7f) output += String.fromCharCode(x);
        else if (x <= 0x7ff)
          output += String.fromCharCode(
            0xc0 | ((x >>> 6) & 0x1f),
            0x80 | (x & 0x3f),
          );
        else if (x <= 0xffff)
          output += String.fromCharCode(
            0xe0 | ((x >>> 12) & 0x0f),
            0x80 | ((x >>> 6) & 0x3f),
            0x80 | (x & 0x3f),
          );
        else if (x <= 0x1fffff)
          output += String.fromCharCode(
            0xf0 | ((x >>> 18) & 0x07),
            0x80 | ((x >>> 12) & 0x3f),
            0x80 | ((x >>> 6) & 0x3f),
            0x80 | (x & 0x3f),
          );
      }
      return output;
    }

    /*
     * Encode a string as utf-16
     */
    function str2rstr_utf16le(input) {
      var output = "";
      for (var i = 0; i < input.length; i++)
        output += String.fromCharCode(
          input.charCodeAt(i) & 0xff,
          (input.charCodeAt(i) >>> 8) & 0xff,
        );
      return output;
    }

    function str2rstr_utf16be(input) {
      var output = "";
      for (var i = 0; i < input.length; i++)
        output += String.fromCharCode(
          (input.charCodeAt(i) >>> 8) & 0xff,
          input.charCodeAt(i) & 0xff,
        );
      return output;
    }

    /*
     * Convert a raw string to an array of big-endian words
     * Characters >255 have their high-byte silently ignored.
     */
    function rstr2binb(input) {
      var output = Array(input.length >> 2);
      for (var i = 0; i < output.length; i++) output[i] = 0;
      for (var i = 0; i < input.length * 8; i += 8)
        output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (24 - (i % 32));
      return output;
    }

    /*
     * Convert an array of big-endian words to a string
     */
    function binb2rstr(input) {
      var output = "";
      for (var i = 0; i < input.length * 32; i += 8)
        output += String.fromCharCode(
          (input[i >> 5] >>> (24 - (i % 32))) & 0xff,
        );
      return output;
    }

    /*
     * Main sha256 function, with its support functions
     */
    function sha256_S(X, n) {
      return (X >>> n) | (X << (32 - n));
    }
    function sha256_R(X, n) {
      return X >>> n;
    }
    function sha256_Ch(x, y, z) {
      return (x & y) ^ (~x & z);
    }
    function sha256_Maj(x, y, z) {
      return (x & y) ^ (x & z) ^ (y & z);
    }
    function sha256_Sigma0256(x) {
      return sha256_S(x, 2) ^ sha256_S(x, 13) ^ sha256_S(x, 22);
    }
    function sha256_Sigma1256(x) {
      return sha256_S(x, 6) ^ sha256_S(x, 11) ^ sha256_S(x, 25);
    }
    function sha256_Gamma0256(x) {
      return sha256_S(x, 7) ^ sha256_S(x, 18) ^ sha256_R(x, 3);
    }
    function sha256_Gamma1256(x) {
      return sha256_S(x, 17) ^ sha256_S(x, 19) ^ sha256_R(x, 10);
    }
    function sha256_Sigma0512(x) {
      return sha256_S(x, 28) ^ sha256_S(x, 34) ^ sha256_S(x, 39);
    }
    function sha256_Sigma1512(x) {
      return sha256_S(x, 14) ^ sha256_S(x, 18) ^ sha256_S(x, 41);
    }
    function sha256_Gamma0512(x) {
      return sha256_S(x, 1) ^ sha256_S(x, 8) ^ sha256_R(x, 7);
    }
    function sha256_Gamma1512(x) {
      return sha256_S(x, 19) ^ sha256_S(x, 61) ^ sha256_R(x, 6);
    }

    var sha256_K = new Array(
      1116352408,
      1899447441,
      -1245643825,
      -373957723,
      961987163,
      1508970993,
      -1841331548,
      -1424204075,
      -670586216,
      310598401,
      607225278,
      1426881987,
      1925078388,
      -2132889090,
      -1680079193,
      -1046744716,
      -459576895,
      -272742522,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      -1740746414,
      -1473132947,
      -1341970488,
      -1084653625,
      -958395405,
      -710438585,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      -2117940946,
      -1838011259,
      -1564481375,
      -1474664885,
      -1035236496,
      -949202525,
      -778901479,
      -694614492,
      -200395387,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      -2067236844,
      -1933114872,
      -1866530822,
      -1538233109,
      -1090935817,
      -965641998,
    );

    function binb_sha256(m, l) {
      var HASH = new Array(
        1779033703,
        -1150833019,
        1013904242,
        -1521486534,
        1359893119,
        -1694144372,
        528734635,
        1541459225,
      );
      var W = new Array(64);
      var a, b, c, d, e, f, g, h;
      var i, j, T1, T2;

      /* append padding */
      m[l >> 5] |= 0x80 << (24 - (l % 32));
      m[(((l + 64) >> 9) << 4) + 15] = l;

      for (i = 0; i < m.length; i += 16) {
        a = HASH[0];
        b = HASH[1];
        c = HASH[2];
        d = HASH[3];
        e = HASH[4];
        f = HASH[5];
        g = HASH[6];
        h = HASH[7];

        for (j = 0; j < 64; j++) {
          if (j < 16) W[j] = m[j + i];
          else
            W[j] = safe_add(
              safe_add(
                safe_add(sha256_Gamma1256(W[j - 2]), W[j - 7]),
                sha256_Gamma0256(W[j - 15]),
              ),
              W[j - 16],
            );

          T1 = safe_add(
            safe_add(
              safe_add(safe_add(h, sha256_Sigma1256(e)), sha256_Ch(e, f, g)),
              sha256_K[j],
            ),
            W[j],
          );
          T2 = safe_add(sha256_Sigma0256(a), sha256_Maj(a, b, c));
          h = g;
          g = f;
          f = e;
          e = safe_add(d, T1);
          d = c;
          c = b;
          b = a;
          a = safe_add(T1, T2);
        }

        HASH[0] = safe_add(a, HASH[0]);
        HASH[1] = safe_add(b, HASH[1]);
        HASH[2] = safe_add(c, HASH[2]);
        HASH[3] = safe_add(d, HASH[3]);
        HASH[4] = safe_add(e, HASH[4]);
        HASH[5] = safe_add(f, HASH[5]);
        HASH[6] = safe_add(g, HASH[6]);
        HASH[7] = safe_add(h, HASH[7]);
      }
      return HASH;
    }

    function safe_add(x, y) {
      var lsw = (x & 0xffff) + (y & 0xffff);
      var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
      return (msw << 16) | (lsw & 0xffff);
    }

    var _DIGEST = {
      hex_sha256: function (s) {
        return rstr2hex(rstr_sha256(str2rstr_utf8(s)));
      },
      b64_sha256: function (s) {
        return rstr2b64(rstr_sha256(str2rstr_utf8(s)));
      },
      any_sha256: function (s, e) {
        return rstr2any(rstr_sha256(str2rstr_utf8(s)), e);
      },
      hex_hmac_sha256: function (k, d) {
        return rstr2hex(rstr_hmac_sha256(str2rstr_utf8(k), str2rstr_utf8(d)));
      },
      b64_hmac_sha256: function (k, d) {
        return rstr2b64(rstr_hmac_sha256(str2rstr_utf8(k), str2rstr_utf8(d)));
      },
      any_hmac_sha256: function (k, d, e) {
        return rstr2any(
          rstr_hmac_sha256(str2rstr_utf8(k), str2rstr_utf8(d)),
          e,
        );
      },
      hex_md5: function (s) {
        return binl2hex(core_md5(str2binl(s), s.length * chrsz));
      },
      b64_md5: function (s) {
        return binl2b64(core_md5(str2binl(s), s.length * chrsz));
      },
      str_md5: function (s) {
        return binl2str(core_md5(str2binl(s), s.length * chrsz));
      },
      hex_hmac_md5: function (key, data) {
        return binl2hex(core_hmac_md5(key, data));
      },
      b64_hmac_md5: function (key, data) {
        return binl2b64(core_hmac_md5(key, data));
      },
      str_hmac_md5: function (key, data) {
        return binl2str(core_hmac_md5(key, data));
      },
    };
    /*
     * These are the functions you'll usually want to call
     * They take string arguments and return either hex or base-64 encoded strings
     */
    // _DIGEST.hex_sha256 = function(s){return rstr2hex(rstr_sha256(str2rstr_utf8(s)));};
    //_DIGEST['b64_sha256'] = function(s){ return rstr2b64(rstr_sha256(str2rstr_utf8(s))); };
    //_DIGEST['any_sha256'] = function(s, e) { return rstr2any(rstr_sha256(str2rstr_utf8(s)), e); };
    //_DIGEST['hex_hmac_sha256'] = function(k, d){ return rstr2hex(rstr_hmac_sha256(str2rstr_utf8(k), str2rstr_utf8(d))); };
    //_DIGEST['b64_hmac_sha256'] = function(k, d){ return rstr2b64(rstr_hmac_sha256(str2rstr_utf8(k), str2rstr_utf8(d))); };
    //_DIGEST['any_hmac_sha256'] = function(k, d, e){ return rstr2any(rstr_hmac_sha256(str2rstr_utf8(k), str2rstr_utf8(d)), e); };

    // _DIGEST['hex_md5'] = function(s){ return binl2hex(core_md5(str2binl(s), s.length * chrsz));};
    // _DIGEST['b64_md5'] = function(s){ return binl2b64(core_md5(str2binl(s), s.length * chrsz));};
    //_DIGEST['str_md5'] = function(s){ return binl2str(core_md5(str2binl(s), s.length * chrsz));};
    //_DIGEST['hex_hmac_md5'] = function(key, data) { return binl2hex(core_hmac_md5(key, data)); };
    //_DIGEST['b64_hmac_md5'] = function(key, data) { return binl2b64(core_hmac_md5(key, data)); };
    //_DIGEST['str_hmac_md5'] = function(key, data) { return binl2str(core_hmac_md5(key, data)); };

    return _DIGEST;
  };

  public generateSecurityId(key, value) {
    // let value = boId + "#" + methodName;
    return this.encryptions().hex_hmac_sha256(key, value);
  }

  public jiamBase(value: string) {
    return new Buffer(value).toString("base64");
  }

  public jiemBase(value: string) {
    return new Buffer(value, "base64").toString();
  }

  public RSAEncry(username, password, UUID, code) {
    let g = SYS_ENCRYPT._G;
    let encrypt = new JSEncrypt();
    encrypt.setPublicKey(SYS_ENCRYPT._PublicKey);
    let securityToken = this.jiamBase(username) + g;
    // securityToken += this.jiamBase(password + SYS_ENCRYPT._Salt) + g;
    if (code != undefined) {
      try {
        securityToken += this.jiamBase(password) + g;
      } catch (e) {
        console.log(e);
      }
    } else {
      securityToken += this.jiamBase(password) + g;
    }

    securityToken += new Date().getTime() + g + UUID;
    securityToken = encrypt.encrypt(securityToken);

    // encrypt.setPrivateKey(SYS_ENCRYPT._PrivateKey);
    // var dz = encrypt.decrypt(securityToken);
    // console.log(this.jiemBase(dz.split('#*#')[1]).split(SYS_ENCRYPT._Salt));

    return securityToken;
  }
}



// WEBPACK FOOTER //
// ./src/services/common/encryption.ts